"use client";
import React, { useEffect } from 'react';

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  backdropClassName?: string;
  overlayClassName?: string;
  closeOnBackdropClick?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onClose,
  children,
  backdropClassName = 'bg-black opacity-50',
  overlayClassName = '',
  closeOnBackdropClick = true,
}) => {
  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      // Save current scroll position
      const scrollY = window.scrollY;
      
      // Lock body scroll
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      
      return () => {
        // Restore body scroll
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        
        // Restore scroll position
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center ${overlayClassName}`}>
      {/* Backdrop */}
      <div 
        className={`absolute inset-0 ${backdropClassName}`}
        onClick={closeOnBackdropClick ? onClose : undefined}
      />
      
      {/* Your Custom Content - No default styling */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default CustomModal;